/* 清水材木店 商品ページ：下に出る「価格とカート」の帯。見た目は szk-buy.css
   - すべての商品ページで読む（szk-product-style.liquid。読まない商品は Liquid で決める：3D の型・売り切れ・¥0・追加料金の商品・オークション など）
   - ページの価格が画面の上（上に固定されたヘッダーの下）に隠れたら、下に帯を出す。本物の「カートに追加」が見えていても出したままにする（本人の希望）
   - 金額は、ページの価格の表示をそのまま写す（Globo が選んだオプションの追加料金を足して書きかえるので、カートに入る金額と同じになる）
   - 帯のボタンは、本物の「カートに追加」ボタンを押す（Globo の必須チェックと追加料金、テーマのカートの動きがそのまま効く）。
     必須の項目が空なら、Globo が「この欄は必須項目です。」を出す（.gpo-element.has-error）ので、その項目まで動かす
   - 部品（商品の枠・本物のボタン）が見つからない商品ページでは何もしない（帯を出さない）
   - 2026-10-21 夜：大型だけの szk-product.js から分けた（全部の商品ページに広げるため）。見直しで、二重に作らない・最初の金額だけ読む・
     見張りの付け直し・下のボタンは帯が出ている間だけ上へ・文字を打っている間はしまう、を足した */
(() => {
  'use strict'
  const root = document.querySelector('.product--container')
  if (!root || document.querySelector('.szk-buy')) return

  // 上に固定されたヘッダーの下の端（高さは、上に貼りついている要素から毎回測る）
  const headers = [...document.querySelectorAll('[id*="header"], [class*="header"]')].filter((e) => e.getBoundingClientRect().width > window.innerWidth * 0.5).slice(0, 12)
  const headerBottom = () => {
    let b = 0
    for (const h of headers) {
      const pos = getComputedStyle(h).position
      if (pos !== 'sticky' && pos !== 'fixed') continue
      const r = h.getBoundingClientRect()
      if (r.top <= 1 && r.bottom > b && r.height < window.innerHeight / 2) b = r.bottom
    }
    return b
  }

  const shown = (el) => !!el && el.getClientRects().length > 0
  const pick = (sel) => [...root.querySelectorAll(sel)].find(shown) || null
  const yen = (n) => `¥${Math.round(n).toLocaleString('ja-JP')}`
  // 金額は、価格の表示の最初の数字のかたまりだけを読む（同じ金額が2回書かれていても、つなげて読まない）
  const firstNumber = (t) => { const m = String(t || '').match(/\d[\d,]*/); return m ? Number(m[0].replace(/,/g, '')) : 0 }
  const isYen = () => { const c = window.Shopify?.currency?.active; return !c || c === 'JPY' }

  const atc = () => pick('.product-form--atc-button')
  const priceEl = () => pick('.product--price .price--main')
  const priceOf = (el) => (el ? firstNumber((el.querySelector('.money') || el).textContent) : 0)
  if (!atc() && !root.querySelector('.product-form--atc-button')) return

  // ---- 帯を作る ----
  const bar = document.createElement('div')
  bar.className = 'szk-buy'
  bar.setAttribute('role', 'region')
  bar.setAttribute('aria-label', '価格とカート')
  bar.innerHTML = '<div class="szk-buy__in"><div class="szk-buy__info"><p class="szk-buy__name"></p><p class="szk-buy__sel"></p></div><div class="szk-buy__price"><span class="szk-buy__label">価格（税込）</span><span class="szk-buy__amount"></span></div><button type="button" class="szk-buy__btn">カートに追加</button></div>'
  bar.inert = true
  document.body.append(bar)
  const $ = (c) => bar.querySelector(c)
  $('.szk-buy__name').textContent = (root.querySelector('.product-title')?.textContent || '').trim()

  // ---- 表示を更新 ----
  function update() {
    watch()
    const hasOptions = !!root.querySelector('.gpo-element')
    const real = atc()
    const btn = $('.szk-buy__btn')
    if (real) {
      btn.textContent = (real.querySelector('.atc-button--text')?.textContent || '').trim() || 'カートに追加'
      btn.disabled = real.disabled || real.classList.contains('disabled')
    }
    const variant = root.querySelector('select.form-options, select[name="id"]')
    $('.szk-buy__sel').textContent = (variant?.selectedOptions?.[0]?.textContent || '').replace(/\s+-\s+[¥￥][\s\S]*$/, '').trim()
    const qty = Math.max(1, firstNumber(pick('[name="quantity"]')?.value) || 1)
    const main = isYen() ? priceOf(priceEl()) : 0 // 円以外で表示しているときは、金額を出さない（読み違えないように）
    $('.szk-buy__amount').textContent = main ? yen(main) : ''
    $('.szk-buy__label').textContent = main ? `${qty > 1 ? '1台あたり・' : ''}税込${hasOptions ? '（選んだオプション込み）' : ''}` : ''
  }
  let t = 0
  const later = () => { clearTimeout(t); t = setTimeout(update, 120) }
  root.addEventListener('change', later)
  root.addEventListener('click', later)
  root.addEventListener('input', later)
  // 価格と本物のボタンの変化を見張る。テーマや Globo が部品を作り直したら、新しい部品に付け直す
  const priceMo = new MutationObserver(later)
  const atcMo = new MutationObserver(later)
  let watchedPrice = null
  let watchedAtc = null
  function watch() {
    const p = priceEl()
    if (p !== watchedPrice) { priceMo.disconnect(); if (p) priceMo.observe(p, { childList: true, subtree: true, characterData: true }); watchedPrice = p }
    const a = atc()
    if (a !== watchedAtc) { atcMo.disconnect(); if (a) atcMo.observe(a, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] }); watchedAtc = a }
  }

  // ---- 出す・しまう ----
  // 価格が、上に固定されたヘッダーの下に隠れたら出す。本物のボタンが見えないとき・文字を打っている間はしまう
  let typing = false
  let lastH = -1
  function place() {
    const pe = priceEl()
    const top = headerBottom()
    const on = !typing && !!atc() && (pe ? pe.getBoundingClientRect().bottom <= top + 2 : window.scrollY > 400)
    if (on !== bar.classList.contains('is-on')) {
      bar.classList.toggle('is-on', on)
      bar.inert = !on // しまっている間は、キーボードで帯のボタンに入らないように
      document.body.classList.toggle('szk-buy-on', on)
      if (on) { update(); if (!searched) { searched = true; whenIdle(liftWidgets); setTimeout(() => whenIdle(liftWidgets), 3000) } }
      setLift(on)
    }
    const h = on ? bar.offsetHeight : 0
    if (h !== lastH) { lastH = h; document.documentElement.style.setProperty('--szk-buy-h', `${h}px`) }
  }
  let raf = 0
  const onScroll = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; place() }) }
  window.addEventListener('scroll', onScroll, { passive: true })
  window.addEventListener('resize', onScroll)
  // スマホで寸法などを打っている間は、帯が入力欄やキーボードの上に重ならないようにしまう
  const isTextField = (e) => e?.matches?.('textarea, input:not([type]), input[type=text], input[type=number], input[type=email], input[type=tel], input[type=search], input[type=url]')
  root.addEventListener('focusin', (e) => { if (isTextField(e.target)) { typing = true; place() } })
  root.addEventListener('focusout', (e) => { if (isTextField(e.target)) { typing = false; setTimeout(place, 50) } })

  // ---- 帯のボタン：本物のボタンを押す。必須の項目が空なら、その項目へ ----
  $('.szk-buy__btn').addEventListener('click', () => {
    const real = atc()
    if (!real || real.disabled || real.classList.contains('disabled')) return
    real.click()
    setTimeout(() => {
      const err = [...document.querySelectorAll('.gpo-element.has-error, .gpo-element .help-block.error')]
        .find((e) => shown(e) && (e.textContent || '').trim())
      if (err) (err.closest('.gpo-element') || err).scrollIntoView({ behavior: 'smooth', block: 'center' })
    }, 450)
  })

  // ---- 画面の下に固定されたほかのボタン（予約カレンダーなど）を、帯が出ている間だけ帯の高さぶん上に逃がす ----
  const lifted = new Map() // 要素 → もとの style の translate・transition
  let searched = false
  const whenIdle = (fn) => (window.requestIdleCallback ? window.requestIdleCallback(fn, { timeout: 800 }) : setTimeout(fn, 200))
  // アプリのボタンはページの中身（テーマのセクション）の外に置かれるので、セクションの中は見ない（重いページでも軽く）
  const SKIP = '.szk-buy, .product--container, main, header, footer, [id^="shopify-section-"], shopify-chat, script, style, link, svg, noscript'
  function liftWidgets() {
    const vh = window.innerHeight
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_ELEMENT, { acceptNode: (n) => (n.matches(SKIP) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT) })
    for (let el = walker.nextNode(); el; el = walker.nextNode()) {
      if (lifted.has(el) || getComputedStyle(el).position !== 'fixed') continue
      const r = el.getBoundingClientRect()
      if (!r.width || !r.height || r.height > 160 || r.width > window.innerWidth * 0.6 || r.bottom < vh - 140 - Math.max(lastH, 0)) continue
      lifted.set(el, { translate: el.style.translate, transition: el.style.transition })
    }
    setLift(bar.classList.contains('is-on'))
  }
  function setLift(on) {
    for (const [el, orig] of lifted) {
      if (on) {
        // もとの動き（CSS の transition）は残し、translate の動きだけ足す
        const base = getComputedStyle(el).transition
        if (!orig.transition && !base.includes('translate')) el.style.transition = base && !/^all 0s/.test(base) ? `${base}, translate .25s ease` : 'translate .25s ease'
        el.style.translate = '0 calc(-1 * var(--szk-buy-h, 0px))'
      } else {
        el.style.translate = orig.translate
        el.style.transition = orig.transition
      }
    }
  }

  // ---- チャットのボタン（Shopify Inbox）を、帯の高さだけ上に逃がす（translate を使い、Inbox 自身の transform の動きは消さない） ----
  function liftChat() {
    const sr = document.querySelector('shopify-chat')?.shadowRoot
    if (!sr || sr.getElementById('szk-lift')) return !!sr
    const st = document.createElement('style')
    st.id = 'szk-lift'
    st.textContent = '.activator{translate:0 calc(-1 * var(--szk-buy-h, 0px))}'
    sr.append(st)
    return true
  }
  if (!liftChat()) {
    const mo = new MutationObserver(() => { if (liftChat()) mo.disconnect() })
    mo.observe(document.body, { childList: true, subtree: true })
    setTimeout(() => mo.disconnect(), 20000)
  }

  update()
  place()
})()
